import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { CompanyProvider } from "@/contexts/CompanyContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Layout from "@/components/layout/Layout";
import Dashboard from "@/pages/Dashboard";
import { Padroncini, Veicoli, Tessere, Clienti, Dipendenti } from "@/pages/Anagrafiche";
import PrimaNota from "@/pages/PrimaNota";
import Imports from "@/pages/Imports";
import Conteggi from "@/pages/Conteggi";
import Scadenzario from "@/pages/Scadenzario";
import Profilo from "@/pages/Profilo";
import Ripartizione from "@/pages/Ripartizione";
import Invii from "@/pages/Invii";
import Utenti from "@/pages/Utenti";
import Consumi from "@/pages/Consumi";
import Pagamenti from "@/pages/Pagamenti";
import Documenti from "@/pages/Documenti";
import Investimento from "@/pages/Investimento";
import Risultato from "@/pages/Risultato";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Caricamento…</div>;
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function Public({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center">Caricamento…</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <CompanyProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Public><Login /></Public>} />
              <Route path="/" element={<Protected><Dashboard /></Protected>} />
              <Route path="/padroncini" element={<Protected><Padroncini /></Protected>} />
              <Route path="/veicoli" element={<Protected><Veicoli /></Protected>} />
              <Route path="/tessere" element={<Protected><Tessere /></Protected>} />
              <Route path="/clienti" element={<Protected><Clienti /></Protected>} />
              <Route path="/prima-nota" element={<Protected><PrimaNota /></Protected>} />
              <Route path="/import" element={<Protected><Imports /></Protected>} />
              <Route path="/conteggi" element={<Protected><Conteggi /></Protected>} />
              <Route path="/scadenzario" element={<Protected><Scadenzario /></Protected>} />
              <Route path="/profilo" element={<Protected><Profilo /></Protected>} />
              <Route path="/ripartizione" element={<Protected><Ripartizione /></Protected>} />
              <Route path="/invii" element={<Protected><Invii /></Protected>} />
              <Route path="/utenti" element={<Protected><Utenti /></Protected>} />
              <Route path="/consumi" element={<Protected><Consumi /></Protected>} />
              <Route path="/dipendenti" element={<Protected><Dipendenti /></Protected>} />
              <Route path="/pagamenti" element={<Protected><Pagamenti /></Protected>} />
              <Route path="/documenti" element={<Protected><Documenti /></Protected>} />
              <Route path="/investimento" element={<Protected><Investimento /></Protected>} />
              <Route path="/risultato" element={<Protected><Risultato /></Protected>} />
            </Routes>
            <Toaster richColors position="bottom-right" />
          </BrowserRouter>
        </CompanyProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
